import React from 'react';
import UserBlackListTable from './common/UserBlackListTable';
import groupsSearchItem from '../../../components/Hocs/GroupsSearchNewCollector/GroupsSearchItem';

const GroupsSearchItem = groupsSearchItem(UserBlackListTable);

export default props => (
  <GroupsSearchItem
    {...props}
    groupName="blackListByCustomers"
    categoryId={1}
    listReduceName="userBlackList.lists.blackListByCustomers"
  />
);



// WEBPACK FOOTER //
// ./src/components/UserBlackList/UserBlackListTable/UserBlackListByCustomers.js